export default __webpack_public_path__ + "static/media/02_Arevatsagi_dzor.fccac306.webp";